import { Description, Divider, LoadingWrapper, TextModal, Title, WrapperButton } from "./styles";
import { TableMuiWithCsvExport } from "../common/TableMui/TableMui";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  selectLoading,
  selectResults,
} from "src/redux/qualify_for_habi/selects";
import FormComponent from "./FilterForm/FilterForm";
import { columnsQualify } from "./constants";
import { useQualifyPropertyHabi } from "./hooks/QualifyPropertyHabi.hook";
import { CustomToolbar } from "../common/TableMui/CustomToolbar";
import { scarpaGray100 } from "@habitech/shared";
import AccordionComponent from "../common/Accordion/Accordion";
import Modal from "../common/modal/Modal";
import { Button } from "@habitech/call-to-action";
import { LinearProgress } from "@mui/material";

export const QualifyProperty = () => {
  const [rows, setRows] = useState([]);
  const {
    handleClick,
    apiRef,
    showModal,
    modalMessage,
    handleSetCloseModal,
    loading_whatsapp
  } = useQualifyPropertyHabi();
  const loading = useSelector(selectLoading);
  const results = useSelector(selectResults);

  useEffect(() => {
    setRows(results);
  }, [results]);

  return (
    <div data-testid={"qualify-property-component"}>
      <Title>Leads calificados para Habi</Title>
      <Description>{}</Description>
      <FormComponent />
      <Divider color={scarpaGray100} />
      <AccordionComponent title={"Opciones para exportar y envío de mensajes"}>
        <CustomToolbar apiRef={apiRef} />
      </AccordionComponent>
      <TableMuiWithCsvExport
        apiRef={apiRef}
        rows={rows}
        columns={columnsQualify}
        loading={loading}
        handleClick={handleClick}
      />
      {showModal && (
        <Modal onClose={handleSetCloseModal}>
          <TextModal>{modalMessage}</TextModal>
          {loading_whatsapp && <LoadingWrapper>
            <LinearProgress />
          </LoadingWrapper>}
          <WrapperButton>
            <Button
              dataId="button-close"
              originType="pcom"
              size="large"
              disabled={loading_whatsapp}
              onClick={() => handleSetCloseModal()}
            >
              Aceptar
            </Button>
          </WrapperButton>
        </Modal>
      )}
    </div>
  );
};
